import React from 'react';
import { Cell, Pie, PieChart, Tooltip } from 'recharts';

import { ChartsData } from '../DiagramComponent';
import CustomTooltip from './CustomTooltip/CustomTooltip';

type Props = {
  data: ChartsData[];
  total: number;
  title: string;
  metricName?: string;
};

const DiagramChart = ({ data, title, total, metricName }: Props): JSX.Element => {
  return (
    <PieChart width={200} height={200}>
      <Pie
        dataKey="value"
        data={data}
        cx={100}
        cy={100}
        innerRadius={60}
        outerRadius={80}
        fill="#8884d8"
        paddingAngle={data.length === 1 ? 0 : 2}
        stroke={data.length === 1 ? 'none' : 'inherit'}
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${entry.name}`} fill={entry.color} />
        ))}
      </Pie>
      <Tooltip content={<CustomTooltip metricName={metricName} title={title} total={total} />} />
    </PieChart>
  );
};

export default DiagramChart;
